import { Nullable } from './../utils'
import { StateIDs } from './Participant'

export interface Outcome {
	dropReason: any
	completionStatus: CompletionStatus
	completionDate?: Date
}

export enum CompletionStatus {
	ENROLLED = 'ENROLLED',
	COMPLETED = 'COMPLETED',
	DROPPED_OUT = 'DROPPED_OUT',
}

export interface ParticipantOutcome {
	academicAwardDetail?:string | null,
	academicCredit?: string | null,
	benefitsProvided?: boolean | null,
	classroomHours?: number | null,
	completionDate?: Date | null,
	completionStatus: CompletionStatus | null,
	credential1?: string | null,
	credential2?: string | null,
	credential3?: string | null,
	credentialType?: string | null,
	creditsEarned?:number | null,
	dropReason?: string | null,
	earnedDegreeOrCredit?: boolean | null,
	incentiveEarned?: IncentiveEarned | null,
	incentiveType?: IncentiveType | null,
	incumbentEmployer?: string | null,
	internshipEmployer?: string | null,
	internshipIndustry?: string | null,
	internshipOccupation?: string | null,
	jobPlacementEmployer?: string | null,
	jobPlacementEmployerAddress1?: string | null,
	jobPlacementEmployerAddress2?: string | null,
	jobPlacementEmployerCity?: string | null,
	jobPlacementEmployerState?: StateIDs | string | null,
	jobPlacementEmployerZipcode?: string | null,
	jobPlacementWeeklyHours?:number | null,
	jobPlacementIndustry?: string | null,
	jobPlacementOccupation?: string | null,
	jobPlacementWage?: number | null,
	jobPlacementWageFrequency?: string | null,
	jobTitle?: string | null,
	paidHours?:number | null,
	participantEnrollmentType?: number | null,
	perDiem?: boolean | null,
	placedDirect?: boolean | null,
	placedJob?: boolean | null,
	placedJobDate?: Date | null,
	placedTraining?: boolean | null,
	positionBackfilled?: boolean | null,
	promotion?: boolean | null,
	startDate?: Date | null,
	stipendAmount?: number | null,
	stipendFrequency?: StipendFrequency | null,
	stipendReceived?:boolean | null,
	trainingHours?:number | null,
	unpaidHours?:number | null,
	wageAmount?: number | null,
	wageFrequency?: WageFrequency | null,
	wageIncrease?: boolean | null,
	wblType?: string | null,
	serviceProvided?: Nullable<boolean>,
	serviceStartDate?: Nullable<Date>,
	serviceEndDate?: Nullable<Date>,
	services?: SupportiveService[],
  // measurableSkillGain?: Nullable<string>,
  // dateSkillAttained?: Nullable<Date>,
  dateCredentialAttained?: Nullable<Date>,
  dateCredentialAttained1?: Nullable<Date>,
  dateCredentialAttained2?: Nullable<Date>,
  credentialType2?: Nullable<string>,
  credentialDoc1Uploaded: Nullable<number>,
  credentialDoc2Uploaded: Nullable<number>,
  errors?: any,
  external_id?:string,
}

export interface ActivityOutcome {
	academicAwardDetail?: Nullable<string>
	academicCredit?: Nullable<string>
	earnedDegreeOrCredit?: Nullable<boolean>
	creditsEarned: Nullable<string | number>
	currentGrade: Nullable<number>
	careerExplorationType: Nullable<CareerExplorationType>
	credential1?: Nullable<string>
	credential2?: Nullable<string>
	credential3?: Nullable<string>
	credentialType?: Nullable<string>
	endDate: Nullable<Date>
	incentiveEarned?: Nullable<IncentiveEarned>
	incentiveType?: Nullable<IncentiveType>
	schoolNames: Nullable<string>
	startDate: Nullable<Date>
	totalHours: Nullable<number>
	totalParticipantsCompleted: Nullable<number>
	totalParticipantsEnrolled: Nullable<number>
	stipendAmount?: Nullable<number>
	stipendFrequency?: Nullable<StipendFrequency>
	stipendReceived?: Nullable<boolean>
	wageAmount?: Nullable<number>
	wageFrequency?: WageFrequency | null
  dateCredentialAttained?: Nullable<Date>
  
}

export const CompletionStatusList: string[] = Object.keys(CompletionStatus).filter(i => isNaN(+i));

export const CompletionStatusItems = [
	{
		label: 'Enrolled',
		value: CompletionStatus.ENROLLED
	},
	{
		label: 'Dropped Out',
		value: CompletionStatus.DROPPED_OUT
	},
	{
		label: 'Completed',
		value: CompletionStatus.COMPLETED
	}
]

export const CompletionOutcomeStatusItems = [
	{
		label: CompletionStatus.ENROLLED,
		value: 'Enrolled'
	},
	{
		label: CompletionStatus.DROPPED_OUT,
		value: 'Dropped Out'
	},
	{
		label: CompletionStatus.COMPLETED,
		value: 'Completed'
	}
]

export const isEnrolled = (status?: {label: string, value: CompletionStatus | null}) => {
	return status &&
		status.value &&
		CompletionStatus[status.value] === CompletionStatus.ENROLLED
}

export enum IncentiveEarned {
	INCENTIVE = 'INCENTIVE',
	STIPEND = 'STIPEND',
	WAGE = 'WAGE'
}

export const IncentiveEarnedItems = [
	{
		label: 'Incentive',
		value: IncentiveEarned.INCENTIVE
	},
	{
		label: 'Stipend',
		value: IncentiveEarned.STIPEND
	},
	{
		label: 'Wage',
		value: IncentiveEarned.WAGE
	}
]

export enum IncentiveType {
	BOOKS = 'BOOKS',
	CLOTHING = 'CLOTHING',
	FOOD = 'FOOD',
	GIFT_CARD = 'GIFT_CARD',
	TRANSPORTATION = 'TRANSPORTATION'
}

export const IncentiveTypeItems = [
	{
		label: 'Books / Studying Materials',
		value: IncentiveType.BOOKS
	},
	{
		label: 'Clothing',
		value: IncentiveType.CLOTHING
	},
	{
		label: 'Food',
		value: IncentiveType.FOOD
	},
	{
		label: 'Gift Card',
		value: IncentiveType.GIFT_CARD
	},
	{
		label: 'Transportation',
		value: IncentiveType.TRANSPORTATION
	}
]

export enum StipendFrequency {
	BEGINNING = 'BEGINNING',
	MULTIPLE = 'MULTIPLE',
	COMPLETION = 'COMPLETION'
}

export const StipendFrequencyItems = [
	{
		label: 'At the beginning of training',
		value: StipendFrequency.BEGINNING
	},
	{
		label: 'Multiple times throughout the training (ex. weekly or biweekly)',
		value: StipendFrequency.MULTIPLE
	},
	{
		label: 'Upon completion of training',
		value: StipendFrequency.COMPLETION
	}
]

export enum WageFrequency {
	HOUR = 'HOUR',
	WEEK = 'WEEK',
	YEAR = 'YEAR'
}

export const WageFrequencyItems = [
	{
		label: '/hour',
		value: WageFrequency.HOUR
	},
	{
		label: '/week',
		value: WageFrequency.WEEK
	},
	{
		label: '/year',
		value: WageFrequency.YEAR
	}
]

export enum CareerExplorationType {
	PORTFOLIO_CREATION = 'PORTFOLIO_CREATION',
	CAREER_PANEL = 'CAREER_PANEL',
	CAREER_FAIR = 'CAREER_FAIR',
	FIELD_TRIP_VISIT = 'FIELD_TRIP_VISIT',
	INDUSTRY_RESEARCH = 'INDUSTRY_RESEARCH',
	JOB_SHADOW = 'JOB_SHADOW',
	ESSENTIAL_SKILLS = 'ESSENTIAL_SKILLS',
}
export const CareerExplorationItems = [
	{
		label: 'Portfolio Creation',
		value: CareerExplorationType.PORTFOLIO_CREATION,
	},
	{
		label: 'Career Panel',
		value: CareerExplorationType.CAREER_PANEL,
	},
	{
		label: 'Career Fair',
		value: CareerExplorationType.CAREER_FAIR,
	},
	{
		label: 'Field Trip / Site Visit',
		value: CareerExplorationType.FIELD_TRIP_VISIT,
	},
	{
		label: 'Industry Research / Curriculum',
		value: CareerExplorationType.INDUSTRY_RESEARCH,
	},
	{
		label: 'Job Shadow',
		value: CareerExplorationType.JOB_SHADOW,
	},
	{
		label: 'Essential Skills / Work Readiness Curriculum',
		value: CareerExplorationType.ESSENTIAL_SKILLS,
	},
]

export const CareerExplorationSchoolNameItems = [
	{
		label: 'Portfolio Creation',
		value: CareerExplorationType.PORTFOLIO_CREATION,
	},
]

export enum SupportiveService {
	APPEARANCE = 'APPEARANCE',
	BILLS = 'BILLS',
	CHILDCARE = 'CHILDCARE',
	COUNSELING = 'COUNSELING',
	FINANCE = 'FINANCE',
	FOOD = 'FOOD',
	HOUSING = 'HOUSING',
	LEGAL = 'LEGAL',
	MEDICAL = 'MEDICAL',
	OTHER = 'OTHER',
	SNAP = 'SNAP',
	SOCIAL = 'SOCIAL',
	TECHNOLOGY = 'TECHNOLOGY',
	TRANSPORTATION = 'TRANSPORTATION'
}

export const SupportiveServiceItems = [
	{
		label: 'Personal appearance (ex. clothing, haircuts)',
		value: SupportiveService.APPEARANCE
	},
	{
		label: 'Bill payments (ex. utilities)',
		value: SupportiveService.BILLS
	},
	{
		label: 'Childcare',
		value: SupportiveService.CHILDCARE
	},
	{
		label: 'Referral to counseling (ex. mental health, substance abuse)',
		value: SupportiveService.COUNSELING
	},
	{
		label: 'Personal finance resources (ex. financial coaching, fees to open bank accounts)',
		value: SupportiveService.FINANCE
	},
	{
		label: 'Groceries/Meals',
		value: SupportiveService.FOOD
	},
	{
		label: 'Rent/Emergency housing',
		value: SupportiveService.HOUSING
	},
	{
		label: 'Legal services (except payment of fines or charge expungement)',
		value: SupportiveService.LEGAL
	},
	{
		label: 'Medical expenses (ex. co-pay, dental services, eyeglasses)',
		value: SupportiveService.MEDICAL
	},
	{
		label: 'Other',
		value: SupportiveService.OTHER
	},
	{
		label: 'Participant currently receiving SNAP or TANF benefits',
		value: SupportiveService.SNAP
	},
	{
		label: 'Referral to social assistance (ex. RIWorks, SNAP)',
		value: SupportiveService.SOCIAL
	},
	{
		label: 'Technology/Internet service',
		value: SupportiveService.TECHNOLOGY
	},
	{
		label: 'Transportation (ex. bus pass, rideshare, emergency car repairs, driver’s license)',
		value: SupportiveService.TRANSPORTATION
	}
]
